import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SurveyService } from '@ps/survey-data-access';

@Injectable({ providedIn: 'root' })
export class SurveyManagementService {
  private readonly _surveyService = inject(SurveyService);

  public assignBuyerProjectManager(
    surveyId: number,
    projectManagerId: number,
  ): Observable<void> {
    return this._surveyService.patchSurvey(
      surveyId,
      [{ op: 'replace', path: '/bpm', value: projectManagerId }],
      'page',
    );
  }

  public removeBuyerProjectManager(surveyId: number): Observable<void> {
    return this._surveyService.patchSurvey(
      surveyId,
      [{ op: 'remove', path: '/bpm' }],
      'page',
    );
  }

  public assignOperatorProjectManager(
    surveyId: number,
    projectManagerId: number,
  ): Observable<void> {
    return this._surveyService.patchSurvey(
      surveyId,
      [{ op: 'replace', path: '/pm', value: projectManagerId }],
      'page',
    );
  }

  public removeOperatorProjectManager(surveyId: number): Observable<void> {
    return this._surveyService.patchSurvey(
      surveyId,
      [{ op: 'remove', path: '/pm' }],
      'page',
    );
  }
}
